<template>
  <div class="container">
    <h1>New Rule</h1>
    <item-form v-on:save-item="patchData()" :item="item" :errors="errors"></item-form>
    <p class="text-center">
      <button type="button" class="btn btn-primary" @click="postData()">Save</button>
      <router-link class="btn btn-secondary" :to="`/rules`">Cancel</router-link>
    </p>
  </div>
</template>

<script>
import ItemForm from "@/components/rule/_Form";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "rule-new",
  components: {
    ItemForm
  },
  data() {
    return {
      item: {
        ruleset: null,
        type: null,
        name: null,
        summary: null,
        description: null
      },
      errors: {}
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      ruleset: state => state.session.user.settings.ruleset
    })
  },
  mounted() {
    this.$Progress.finish();
    this.$embers.pageData("New Rule");
    this.item.ruleset = this.ruleset;
  },
  methods: {
    ...mapActions({
      rulesCreate: "rules/create"
    }),
    async postData() {
      try {
        let item = await this.rulesCreate(this.item);
        this.$router.push({ path: `/rules/${item._id}` });
      } catch (err) {
        this.errors = Object.assign({}, this.errors, err.response.data);
      }
    }
  }
};
</script>
